module.exports = __webpack_public_path__ + "static/media/icarros-alpha.00db357e.png";